/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartVaccinesAliases {
  CONTEXTUAL_BAR_VACCINES = 'contextual-bar-vaccines',
  DECK_VACCINES = 'deck-vaccines',
  FETCH_VACCINES = 'fetch-vaccines',
  LAYOUT_MY_CHART_VACCINES = 'layout-my-chart-vaccines',
  LEGENDS_VACCINE = 'legends-vaccine',
  MY_CHART_VACCINE_CARD_DECK_VACCINES_MY_CHART_VACCINES = 'my-chart-vaccine-card-deck-vaccines-my-chart-vaccines',
  PANEL_VACCINES_MY_CHART_VACCINES = 'panel-vaccines-my-chart-vaccines',
}
export { MyChartVaccinesAliases };
